import "pwm_global/styling/global.scss";
import React from "react";
import "./main.scss";
import { createRoot } from "react-dom/client";
import { App } from "./app.jsx";

const location = window.appData.location;

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(<App location={location} />);
});
